/**
 * 曼陀罗 答题和报告的路由
 * 禅道链接
 * http://112.124.122.87:8084/index.php?m=story&f=view&storyID=4847
 */

 import { loadPageFail } from '../lib/units';

  export default [
    {
      name: 'daturaAnswer',
      path: '/daturaAnswer',
      meta: {
        title: '答题测试说明页'
      },
      component: resolve => require(['../pages/datura/daturaAnswer.vue'], resolve, (err) => {
        loadPageFail({
          pagename: '曼陀罗测试说明页',
          err
        })
      }),
    },
    {
      name: 'daturaSelect',
      path: '/daturaSelect',
      meta: {
        title: '选择图案'
      },
      component: resolve => require(['../pages/datura/daturaSelect.vue'], resolve, (err) => {
        loadPageFail({
          pagename: '曼陀罗选择图案页',
          err
        })
      }),
    },
    // 假题路由-假题版本
    {
      name: 'daturaSelectList',
      path: '/daturaSelectList',
      meta: {
        title: '选择答案'
      },
      component: resolve => require(['../pages/datura/mockList.vue'], resolve, (err) => {
        loadPageFail({
          pagename: '曼陀罗选择题',
          err
        })
      }),
    },
    {
      name: 'daturaList',
      path: '/daturaList',
      meta: {
        title: '答题页'
      },
      component: resolve => require(['../pages/datura/daturaList.vue'], resolve, (err) => {
        loadPageFail({
          pagename: '曼陀罗答题页',
          err
        })
      }),
    },
    {
      name: 'daturaReport',
      path: '/daturaReport',
      meta: {
        title: '报告页'
      },
      component: resolve => require(['../pages/datura/daturaReport.vue'], resolve, (err) => {
        loadPageFail({
          pagename: '曼陀罗报告页',
          err
        })
      }),
    },
  ]



// WEBPACK FOOTER //
// ./src/router/datura.js